import { EnrichedProduct, FeatureDTO } from '@wix/package-picker-common';
import { FeatureRow } from '@wix/package-picker-components';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Text } from '@wix/design-system';
import { TooltipLink } from './TooltipLink';

interface GridFeatureGroupProps {
  feature: FeatureDTO;
  products: EnrichedProduct[];
}

export const GridFeatureRow: React.FC<GridFeatureGroupProps> = ({
  feature,
  products,
}) => {
  const { t } = useTranslation();

  if (!feature) {
    return <></>;
  }

  const size = 'small';

  const translationTags = {
    b: <b />,
    ul: <ul />,
    li: <li />,
    url: (
      <TooltipLink
        size={size}
        feature={feature}
        onClick={() => {
          // TODO: Add BI event
        }}
      />
    ),
  };

  return (
    <FeatureRow key={feature.id} size='small'>
      <FeatureRow.Cell align='space-between'>
        <FeatureRow.Header
          name={t(feature.name)}
          description={
            <Text size={size}>
              <Trans i18nKey={feature.tooltip} components={translationTags} />
            </Text>
          }
          badge={
            feature.displayProperties?.hasNewBadge
              ? t('features.new_feature.new_badge')
              : ''
          }
          note={t(feature.note ?? '')}
          // descriptionAsSubtitle={descriptionAsSubtitle}
          // isDescriptionSecondary={isJapanesePackagePicker}
          // nameWeight={isJapanesePackagePicker ? 'bold' : 'normal'}
        />
      </FeatureRow.Cell>
      {products.map((prod) => {
        // TODO: Refactor
        const productId = prod.productId ?? '';
        const text =
          typeof feature.productsValueMap[productId] === 'string' ||
          typeof feature.productsValueMap[productId] === 'number' ? (
            <Trans i18nKey={`${feature.productsValueMap[productId]}`} />
          ) : undefined;
        return (
          <FeatureRow.Cell key={prod.name}>
            <FeatureRow.Value
              isEnabled={feature.includedInProducts.includes(productId)}
              text={text}
            />
          </FeatureRow.Cell>
        );
      })}
    </FeatureRow>
  );
};
